import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Search, Smartphone, Database, RefreshCw, Users } from 'lucide-react';
const features = [{
  category: 'Custom, SEO-Optimized Website',
  items: [{
    icon: Search,
    title: 'Fully Custom WordPress',
    description: "Not a cookie-cutter template. Built from scratch to reflect your dealership's brand and goals."
  }, {
    icon: Users,
    title: 'Buyer-Centric Design',
    description: 'Designed around how boat buyers actually shop: search filters, model detail pages, and easy-to-use navigation.'
  }, {
    icon: Smartphone,
    title: 'Mobile-First Performance',
    description: 'Fast, mobile-friendly, responsive design - essential since many buyers browse on phones/tablets.'
  }]
}, {
  category: 'Seamless Inventory & System Integration',
  items: [{
    icon: Database,
    title: 'Automatic Integration',
    description: 'Automatic integration with dealer inventory / listing systems or DMS.'
  }, {
    icon: RefreshCw,
    title: 'Live Inventory Sync',
    description: 'Automatic sync of boat listings, photos, specs - ensures your site is always up-to-date with real stock.'
  }, {
    icon: Zap,
    title: 'Smart Lead Capture',
    description: 'Customizable lead capture tools & CRM integration - make it easy for serious buyers to reach you.'
  }]
}];
export function FeaturesSection() {
  return <section className="py-20 bg-white" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="text-center mb-16" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-4" data-id="element-62">
            What You Get with DealersChoice
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-63">
            A complete digital ecosystem designed specifically for the marine
            industry.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-64">
          {features.map((group, groupIndex) => <div key={groupIndex} className="space-y-8" data-id="element-65">
              <h3 className="text-2xl font-bold text-[#0A2540] border-b-2 border-[#D4AF37] pb-4 inline-block" data-id="element-66">
                {group.category}
              </h3>

              <div className="space-y-8" data-id="element-67">
                {group.items.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: (groupIndex * 3 + index) * 0.1
            }} className="flex gap-4" data-id="element-68">
                    <div className="flex-shrink-0" data-id="element-69">
                      <div className="w-12 h-12 rounded-lg bg-[#0A2540]/5 flex items-center justify-center" data-id="element-70">
                        <feature.icon className="w-6 h-6 text-[#0A2540]" data-id="element-71" />
                      </div>
                    </div>
                    <div data-id="element-72">
                      <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-73">
                        {feature.title}
                      </h4>
                      <p className="text-gray-600 leading-relaxed" data-id="element-74">
                        {feature.description}
                      </p>
                    </div>
                  </motion.div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}